import { CampaignCardOpenType, CardLayouts, ReactBootstrap } from '@loyalty/editor-components';
import { Editor } from 'grapesjs';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faBullhorn } from '@fortawesome/pro-solid-svg-icons/faBullhorn';
import { faCog } from '@fortawesome/pro-solid-svg-icons/faCog';
import { getLocalizedProperty } from '@loyalty/shared-common';
import { renderToString } from 'react-dom/server';
import { CampaignCardTraits, campaignCardTraitsSchema } from './CampaignCardTraits';
import { EditorComponentDefinition } from '../types';

export const campaignCardComponentDefinition: EditorComponentDefinition = {
  id: 'campaign-card',
  icon: faBullhorn,
  category: 'Content',
  getLabel: ({ t }) => t('editor.component.campaign-card'),
  component: Component,
  traits: {
    schema: campaignCardTraitsSchema,
    form: CampaignCardTraits,
  },
  copyPasteHelper: (element, context) => {
    element.i18nAttributes = { campaignId: '', channelUuid: '' };
  },
};

function Component(editor: Editor) {
  const languages = editor.Config?.context?.languages || [];
  const qualifioApiUrl = editor.Config?.context?.qualifioApiUrl;
  const campaignFeedApiHost = `${qualifioApiUrl}/v1/campaignfeed`;
  const i18n = editor.I18n;

  editor.DomComponents.addType(campaignCardComponentDefinition.id, {
    model: {
      defaults: {
        attributes: {
          template: CardLayouts.DEFAULT,
          openType: CampaignCardOpenType.newTab,
        },
        i18nAttributes: Object.fromEntries(
          languages.map((l: string) => [l, { campaignId: '', channelUuid: '' }]),
        ),
        selectable: true,
        draggable: '[data-gjs-type=column]',
        droppable: false,
        traits: [],
      },
      toHTML() {
        const locale = i18n.getLocale();
        return renderToString(
          <div className="qlfeditor-non-interactive-component">
            <div className="qlfeditor-non-interactive-hover-mask">
              <p>{i18n.t('editor.non-interactive.hover.mask')}</p>
            </div>
            <ReactBootstrap
              component="CampaignCard"
              props={{
                id: this.getId(),
                layoutId: this.attributes.attributes.template,
                channelUuid: getLocalizedProperty(this.attributes, 'channelUuid', locale),
                openType: this.attributes.attributes.openType,
                className: this.getAttributes().class,
                locale,
                campaignFeedApiHost,
                overrides: {
                  title: getLocalizedProperty(this.attributes, 'title', locale),
                  image: getLocalizedProperty(this.attributes, 'image', locale),
                  description: getLocalizedProperty(this.attributes, 'description', locale),
                  ctaLabel: getLocalizedProperty(this.attributes, 'ctaLabel', locale),
                },
              }}
              document={editor.Canvas.getDocument()}
              componentType="campaign-card"
            />
          </div>,
        );
      },
    },
    view: {
      onRender() {
        const { el, model } = this;
        el.innerHTML = model.toHTML();
      },
    },
  });
}
